import React, { useEffect, useState } from "react";
import "./LineDesign.css";
import { lineDesign } from "../../config/images";
import { getDeviceTagByType } from "../VMS/VmsCompanyDashboard/VmsMachine/service";
import Mqqtdata from "../ProcessDashboard/Mqqtdata";
import { SoftTagFormula } from "../SmartTag/softTag/SoftTagFormula";
import { getPlantByID } from "../SuperAdminDashboard/service";
import { getDeviceTagByTypeNew } from "../ProcessDashboard/service";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const meters = [
  { id: 1, label: "F1 O/G 100A" },
  { id: 2, label: "F1 O/G 125A" },
  { id: 3, label: "F1 O/G 125A" },
  { id: 4, label: "F1 O/G 125A" },
  { id: 5, label: "F1 O/G 200A" },
];
const meters1 = [
  { id: 1, label: "F11 O/G 100A" },
  { id: 2, label: "F11 O/G 125A" },
  { id: 3, label: "F11 O/G 125A" },
  { id: 4, label: "F11 O/G 200A" },
];
const meters2 = [
  { id: 1, label: "HT Meter 1" },
  { id: 2, label: "HT Meter 2" },
  { id: 3, label: "HT Meter 3" },
];
const meters3 = [
  { id: 1, label: "2000 A-1" },
  { id: 2, label: "2000 A-2" },

];
const metersData2 = [
  [{ id: 1, label: "F2 O/G 400A", direction: "upward" }],
  [
    { id: 2, label: "F2 O/G 630A", direction: "upward" },
    { id: 3, label: "DG-1", direction: "downward" },
  ],
  [{ id: 4, label: "F2 O/G 1250A", direction: "upward" }],
  [
    { id: 5, label: "F3 O/G 2000A", direction: "upward" },
    { id: 6, label: "GEB-1", direction: "downward" },
  ],
  [{ id: 7, label: "F9 O/G 2000A", direction: "upward" }],
  [
    { id: 8, label: "F10 O/G 400A", direction: "upward" },
    { id: 9, label: "GEB-2", direction: "downward" },
  ],
  [{ id: 10, label: "F10 O/G 630A", direction: "upward" }],
  [
    { id: 11, label: "F10 O/G 1250A", direction: "upward" },
    { id: 12, label: "DG-2", direction: "downward" },
  ],
];
const metersData3 = [
  [{ id: 1, label: "F2 O/G 400A", direction: "upward" }],
  [
    { id: 2, label: "F2 O/G 630A", direction: "upward" },
    { id: 3, label: "SYNCH RELAY 1", direction: "downward" },
  ],
  [{ id: 4, label: "F2 O/G 1250A", direction: "upward" }],
  [
    { id: 5, label: "F3 O/G 2000A", direction: "upward" },
    { id: 6, label: "SYNCH RELAY 2", direction: "downward" },
  ],
  [],
  [
    { id: 8, label: "F10 O/G 400A", direction: "upward" },
    { id: 9, label: "SYNCH RELAY 3", direction: "downward" },
  ],
  [{ id: 10, label: "F10 O/G 630A", direction: "upward" }],
  [
    { id: 11, label: "F10 O/G 1250A", direction: "upward" },
    { id: 12, label: "SYNCH RELAY 4", direction: "downward" },
  ],
];

// const metersData3 = [
//   [{ id: 1, label: "SYNCH RELAY 1", direction: "downward" }],
//   [{ id: 1, label: "SYNCH RELAY 0", direction: "upward" }],
//   [{ id: 1, label: "SYNCH RELAY 2", direction: "downward" }],
//   [{ id: 1, label: "SYNCH RELAY 3", direction: "downward" }],
//   [{ id: 1, label: "SYNCH RELAY 4", direction: "upward" }],
//   [{ id: 1, label: "SYNCH RELAY 4", direction: "downward" }],
// ];

const LineDesign = ({ deviceIds }) => {
  const [activePage, setActivePage] = useState(1);
  const [deviceData, setDeviceData] = useState([]);
  const [mqttTagData, setMqttTagData] = useState();

  const [topics, setTopics] = useState([]);

  const mergedArray = mqttTagData
    ? [].concat(...Object.values(mqttTagData))
    : [];

  const mqttDataReduce = mergedArray.reduce((map, item) => {
    map[item.device_tag] = Number(item.tagValue);
    return map;
  }, {});

  useEffect(() => {
    if (deviceData.length) {
      const topicArray = deviceData.flatMap(
        (plant) => "Hikar/DeviceUID/" + plant.device__uid
      );

      setTopics(topicArray);
    }
  }, [deviceData]);

  const handleNextClick = () => {
    setActivePage((prevPage) => (prevPage === 2 ? 0 : prevPage + 1));
  };

  const handlePreviousClick = () => {
    setActivePage((prevPage) => (prevPage === 0 ? 2 : prevPage - 1));
  };

  useEffect(() => {
    handleCallAPI();
  }, [deviceIds]);

  const handleCallAPI = async () => {
    const params = {
      company_id: 145,
      device_id: deviceIds?.map((e) => e.id),
      plant_id: 110,
    };
    try {
      const resp = await getDeviceTagByTypeNew(params);
      if (resp.status == 200 || resp.status == 201) {
        setDeviceData(resp.data.payload);
      }
    } catch (error) {
      setDeviceData([]);
    }
  };

  const shouldBreak = (index) => {
    const breakPoints = [3, 6]; // Break after the 4th and 7th element
    return breakPoints.includes(index);
  };

  return (
    <>
      {topics.length ? (
        <Mqqtdata topics={topics} setMqttTagData={setMqttTagData} />
      ) : null}

      <div className="line-data">
        <div className="main-content">
          {activePage == 1 ? (
            <h1
              style={{
                width: "fit-content",
                padding: "9px 40px",
                background: "#d3d3d3",
                textAlign: "center",
                fontWeight: 600,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              MAIN
            </h1>
          ) : activePage == 3 ? (
            <h1
              style={{
                width: "fit-content",
                padding: "9px 40px",
                background: "#d3d3d3",
                textAlign: "center",
                fontWeight: 600,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              DG SYNCH PANEL
            </h1>
          ) : activePage == 4 ? (
            <h1
              style={{
                width: "fit-content",
                padding: "9px 40px",
                background: "#d3d3d3",
                textAlign: "center",
                fontWeight: 600,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              HT PANEL
            </h1>
          ) : activePage == 5 ? (
            <h1
              style={{
                width: "fit-content",
                padding: "9px 40px",
                background: "#d3d3d3",
                textAlign: "center",
                fontWeight: 600,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              I/C POWER
            </h1>
          ) : (
            ""
          )}

          {activePage !== 0 && (
            <img
              src={lineDesign.leftArrowIcon}
              alt="left-arrow"
              className="left-arrow"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (activePage === 3 || activePage === 4 || activePage === 5) {
                  setActivePage(1);
                } else {
                  handlePreviousClick();
                }
              }}
            />
          )}
          {activePage == 0 && (
            <>
              <div className="busbar2">
                {meters.map((meter, index) => (
                  <div key={index} className="connection-point">
                    <img
                      src={lineDesign.dotIcon}
                      alt="dot-icon"
                      className="dot"
                    />
                    <div className="vertical-line"></div>

                    {meter.label == "F1 O/G 100A" &&
                      deviceData
                        .filter((e) => e.id == 377)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F1_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F1_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = lineDesign.crossRedIcon;
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = lineDesign.crossIcon;
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = lineDesign.crossRedIcon;
                            }

                            return (
                              <img
                                src={appliedClass}
                                alt=""
                                className="cross"
                              />
                            );
                          })
                        )}
                    {meter.label == "F1 O/G 125A" &&
                      meter.id == 2 &&
                      deviceData
                        .filter((e) => e.id == 378)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let appliedClass = "";

                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F2_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F2_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = lineDesign.crossRedIcon;
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = lineDesign.crossIcon;
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = lineDesign.crossRedIcon;
                            }

                            return (
                              <img
                                src={appliedClass}
                                alt=""
                                className="cross"
                              />
                            );
                          })
                        )}

                    {meter.label == "F1 O/G 125A" &&
                      meter.id == 3 &&
                      deviceData
                        .filter((e) => e.id == 379)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F3_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F3_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = lineDesign.crossRedIcon;
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = lineDesign.crossIcon;
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = lineDesign.crossRedIcon;
                            }

                            return (
                              <img
                                src={appliedClass}
                                alt=""
                                className="cross"
                              />
                            );
                          })
                        )}
                    {meter.label == "F1 O/G 125A" &&
                      meter.id == 4 &&
                      deviceData
                        .filter((e) => e.id == 380)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F4_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F4_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = lineDesign.crossRedIcon;
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = lineDesign.crossIcon;
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = lineDesign.crossRedIcon;
                            }

                            return (
                              <img
                                src={appliedClass}
                                alt=""
                                className="cross"
                              />
                            );
                          })
                        )}

                    {meter.label == "F1 O/G 200A" &&
                      deviceData
                        .filter((e) => e.id == 381)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";

                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F5_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F5_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = lineDesign.crossRedIcon;
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = lineDesign.crossIcon;
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = lineDesign.crossRedIcon;
                            }

                            return (
                              <img
                                src={appliedClass}
                                alt=""
                                className="cross"
                              />
                            );
                          })
                        )}

                    {meter.label == "F1 O/G 100A" &&
                      deviceData
                        .filter((e) => e.id == 377)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let appliedClass = "";

                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F1_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F1_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = "diagonal-line-off-upward";
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = "diagonal-line";
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = "diagonal-line-green";
                            }

                            return <div className={appliedClass}></div>;
                          })
                        )}
                    {meter.label == "F1 O/G 125A" &&
                      meter.id == 2 &&
                      deviceData
                        .filter((e) => e.id == 378)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F2_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F2_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = "diagonal-line-off-upward";
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = "diagonal-line";
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = "diagonal-line-green";
                            }

                            return <div className={appliedClass}></div>;
                          })
                        )}
                    {meter.label == "F1 O/G 125A" &&
                      meter.id == 3 &&
                      deviceData
                        .filter((e) => e.id == 379)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F3_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F3_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = "diagonal-line-off-upward";
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = "diagonal-line";
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = "diagonal-line-green";
                            }

                            return <div className={appliedClass}></div>;
                          })
                        )}
                    {meter.label == "F1 O/G 125A" &&
                      meter.id == 4 &&
                      deviceData
                        .filter((e) => e.id == 380)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F4_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F4_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = "diagonal-line-off-upward";
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = "diagonal-line";
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = "diagonal-line-green";
                            }

                            return <div className={appliedClass}></div>;
                          })
                        )}
                    {meter.label == "F1 O/G 200A" &&
                      deviceData
                        .filter((e) => e.id == 381)
                        .map((e) =>
                          e.tags.map((tags) => {
                            let tagValue = mergedArray.length
                              ? mergedArray.find(
                                (f) =>
                                  f.device__uid == tags.device__uid &&
                                  f.device_tag == tags.device_tag
                              )?.["tagValue"] || 0.0
                              : 0.0;

                            let appliedClass = "";
                            const tripTag = mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == "P_1F5_TRIP_FB"
                            );
                            const onTag = mergedArray.find(
                              (f) =>
                                f.device__uid === tags.device__uid &&
                                f.device_tag == "P_1F5_ON_OFF_FB"
                            );

                            const tripValue = tripTag
                              ? Number(tripTag["tagValue"])
                              : 0;
                            const onValue = onTag
                              ? Number(onTag["tagValue"])
                              : 0;

                            if (tripValue == 0 && onValue == 1) {
                              appliedClass = "diagonal-line-off-upward";
                            } else if (tripValue == 1 && onValue == 0) {
                              appliedClass = "diagonal-line";
                            } else if (tripValue == 0 && onValue == 0) {
                              appliedClass = "diagonal-line-green";
                            }

                            return <div className={appliedClass}></div>;
                          })
                        )}
                    {/* <div className="diagonal-line"></div> */}
                    <div className="meter-unit">
                      <div className="meter-box">
                        <div className="meter-label">{meter.label}</div>
                        <img src={lineDesign.meterBox} alt="meter-icon" />
                        <div className="horizontal-line"></div>
                      </div>
                      <div className="meter-info">
                        <div className="meter-values">
                          {meter.label === "F1 O/G 100A" &&
                            deviceData
                              .filter((e) => e.id == 377)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  if (
                                    tags.is_soft_tag &&
                                    tags.soft_tag_id__formula &&
                                    Object.keys(mqttDataReduce).length
                                  ) {
                                    if (
                                      SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.softTagNotGetTag === true
                                    ) {
                                      tagValue = SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.value;
                                    }
                                  }

                                  const unitLabels = {
                                    V: "VLL",
                                    A: "LN",
                                    PF: "QA",
                                    KW: "KT",
                                    KVAR: "KV",
                                    KVA: "KA",
                                  };

                                  const tagUnitUpper = tags.tag_unit
                                    ? tags.tag_unit.trim().toUpperCase()
                                    : "";

                                  if (unitLabels[tagUnitUpper]) {
                                    return (
                                      <p key={tags.id}>
                                        <span>
                                          {unitLabels[tagUnitUpper]} (
                                          {tags.tag_unit}):
                                        </span>{" "}
                                        {tagValue}
                                      </p>
                                    );
                                  }

                                  return null;
                                })
                              )}
                          {meter.label === "F1 O/G 125A" &&
                            meter.id == 2 &&
                            deviceData
                              .filter((e) => e.id == 378)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  if (
                                    tags.is_soft_tag &&
                                    tags.soft_tag_id__formula &&
                                    Object.keys(mqttDataReduce).length
                                  ) {
                                    if (
                                      SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.softTagNotGetTag === true
                                    ) {
                                      tagValue = SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.value;
                                    }
                                  }

                                  if (
                                    [
                                      "V",
                                      "A",
                                      "PF",
                                      "KW",
                                      "KVAR",
                                      "KVA",
                                    ].includes(tags.tag_unit.toUpperCase())
                                  ) {
                                    let label = "";

                                    switch (tags.tag_unit.toUpperCase()) {
                                      case "V":
                                        label = "VLL";
                                        break;
                                      case "A":
                                        label = "LN"; // No change needed
                                        break;
                                      case "PF":
                                        label = "QA";
                                        break;
                                      case "KW":
                                        label = "KT";
                                        break;
                                      case "KVAR":
                                        label = "KV";
                                        break;
                                      case "KVA":
                                        label = "KA";
                                        break;
                                      default:
                                        label = "";
                                    }

                                    return (
                                      <p key={tags.id}>
                                        <span>
                                          {label} ({tags.tag_unit}):
                                        </span>{" "}
                                        {tagValue}
                                      </p>
                                    );
                                  }

                                  return null;
                                })
                              )}
                          {meter.label === "F1 O/G 125A" &&
                            meter.id == 3 &&
                            deviceData
                              .filter((e) => e.id == 379)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  if (
                                    tags.is_soft_tag &&
                                    tags.soft_tag_id__formula &&
                                    Object.keys(mqttDataReduce).length
                                  ) {
                                    if (
                                      SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.softTagNotGetTag === true
                                    ) {
                                      tagValue = SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.value;
                                    }
                                  }

                                  if (
                                    [
                                      "V",
                                      "A",
                                      "PF",
                                      "KW",
                                      "KVAR",
                                      "KVA",
                                    ].includes(tags.tag_unit.toUpperCase())
                                  ) {
                                    let label = "";
                                    switch (tags.tag_unit.toUpperCase()) {
                                      case "V":
                                        label = "VLL";
                                        break;
                                      case "A":
                                        label = "LN"; // No change needed
                                        break;
                                      case "PF":
                                        label = "QA";
                                        break;
                                      case "KW":
                                        label = "KT";
                                        break;
                                      case "KVAR":
                                        label = "KV";
                                        break;
                                      case "KVA":
                                        label = "KA";
                                        break;
                                      default:
                                        label = "";
                                    }

                                    return (
                                      <p key={tags.id}>
                                        <span>
                                          {label} ({tags.tag_unit}):
                                        </span>{" "}
                                        {tagValue}
                                      </p>
                                    );
                                  }

                                  return null;
                                })
                              )}
                          {meter.label === "F1 O/G 125A" &&
                            meter.id == 4 &&
                            deviceData
                              .filter((e) => e.id == 380)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  if (
                                    tags.is_soft_tag &&
                                    tags.soft_tag_id__formula &&
                                    Object.keys(mqttDataReduce).length
                                  ) {
                                    if (
                                      SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.softTagNotGetTag === true
                                    ) {
                                      tagValue = SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.value;
                                    }
                                  }

                                  if (
                                    [
                                      "V",
                                      "A",
                                      "PF",
                                      "KW",
                                      "KVAR",
                                      "KVA",
                                    ].includes(tags.tag_unit.toUpperCase())
                                  ) {
                                    let label = "";

                                    switch (tags.tag_unit.toUpperCase()) {
                                      case "V":
                                        label = "VLL";
                                        break;
                                      case "A":
                                        label = "LN"; // No change needed
                                        break;
                                      case "PF":
                                        label = "QA";
                                        break;
                                      case "KW":
                                        label = "KT";
                                        break;
                                      case "KVAR":
                                        label = "KV";
                                        break;
                                      case "KVA":
                                        label = "KA";
                                        break;
                                      default:
                                        label = "";
                                    }

                                    return (
                                      <p key={tags.id}>
                                        <span>
                                          {label} ({tags.tag_unit}):
                                        </span>{" "}
                                        {tagValue}
                                      </p>
                                    );
                                  }

                                  return null;
                                })
                              )}
                          {meter.label === "F1 O/G 200A" &&
                            deviceData
                              .filter((e) => e.id == 381)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  if (
                                    tags.is_soft_tag &&
                                    tags.soft_tag_id__formula &&
                                    Object.keys(mqttDataReduce).length
                                  ) {
                                    if (
                                      SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.softTagNotGetTag === true
                                    ) {
                                      tagValue = SoftTagFormula(
                                        tags.soft_tag_id__formula,
                                        mqttDataReduce
                                      )?.value;
                                    }
                                  }

                                  if (
                                    [
                                      "V",
                                      "A",
                                      "PF",
                                      "KW",
                                      "KVAR",
                                      "KVA",
                                    ].includes(tags.tag_unit.toUpperCase())
                                  ) {
                                    let label = "";

                                    switch (tags.tag_unit.toUpperCase()) {
                                      case "V":
                                        label = "VLL";
                                        break;
                                      case "A":
                                        label = "LN"; // No change needed
                                        break;
                                      case "PF":
                                        label = "QA";
                                        break;
                                      case "KW":
                                        label = "KT";
                                        break;
                                      case "KVAR":
                                        label = "KV";
                                        break;
                                      case "KVA":
                                        label = "KA";
                                        break;
                                      default:
                                        label = "";
                                    }
                                    return (
                                      <p key={tags.id}>
                                        <span>
                                          {label} ({tags.tag_unit}):
                                        </span>{" "}
                                        {tagValue}
                                      </p>
                                    );
                                  }

                                  return null;
                                })
                              )}
                        </div>
                      </div>
                    </div>
                    <div className="vertical-line-to-meter"></div>
                  </div>
                ))}
              </div>
            </>
          )}

          {activePage == 1 && (
            <>
              <div className="busbar00">
                {metersData2.map((meterArray, index) => {
                  return (
                    <div
                      key={index}
                      // className={`connection-point ${shouldBreak(index) ? "break-busbar" : ""}`}
                      className="connection-point"
                    >
                      {index == 3 && (
                        <>
                          {deviceData
                            .filter((e) => e.id == 392)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == e.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                let appliedClass = "";
                                const tripTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid == tags.device__uid &&
                                    f.device_tag == "P_BC_TRIP_FB"
                                );
                                const onTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_ON_FB"
                                );

                                const offTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_OFF_FB"
                                );
                                const tripValue = tripTag
                                  ? Number(tripTag["tagValue"])
                                  : 0;
                                const onValue = onTag
                                  ? Number(onTag["tagValue"])
                                  : 0;
                                const offValue = offTag
                                  ? Number(offTag["tagValue"])
                                  : 0;

                                if (
                                  tripValue == 0 &&
                                  onValue == 1 &&
                                  offValue == 0
                                ) {
                                  appliedClass = lineDesign.crossRedIcon;
                                } else if (
                                  tripValue == 1 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = lineDesign.crossIcon;
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 1
                                ) {
                                  appliedClass = lineDesign.crossRedIcon;
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = lineDesign.crossRedIcon;
                                }

                                return (
                                  <>
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="crossdefault"
                                    />
                                  </>
                                );
                              })
                            )}
                          {deviceData
                            .filter((e) => e.id == 392)
                            .map((e, index) =>
                              e.tags.map((tags, i) => {
                                let deviceName = "";
                                if (i === 0) {
                                  deviceName = "Bus Coupler";
                                }
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                let appliedClass = "";

                                // if (
                                //   (["BC_OFF_FB", "BC_TRIP_FB", "BC_ON_FB"].includes(tags.tag_name) &&
                                //     tagValue == 0.0) ||
                                //   tagValue == 0
                                // ) {

                                //   appliedClass = "diagonal-line-off";
                                // } else

                                const tripTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid == tags.device__uid &&
                                    f.device_tag == "P_BC_TRIP_FB"
                                );
                                const onTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_ON_FB"
                                );

                                const offTag = mergedArray.find(
                                  (f) =>
                                    f.device__uid === tags.device__uid &&
                                    f.device_tag == "P_BC_OFF_FB"
                                );
                                const tripValue = tripTag
                                  ? Number(tripTag["tagValue"])
                                  : 0;
                                const onValue = onTag
                                  ? Number(onTag["tagValue"])
                                  : 0;
                                const offValue = offTag
                                  ? Number(offTag["tagValue"])
                                  : 0;

                                if (
                                  tripValue == 0 &&
                                  onValue == 1 &&
                                  offValue == 0
                                ) {
                                  appliedClass = "default-line-on";
                                } else if (
                                  tripValue == 1 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = "default-line";
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 1
                                ) {
                                  appliedClass = "default-line-green";
                                } else if (
                                  tripValue == 0 &&
                                  onValue == 0 &&
                                  offValue == 0
                                ) {
                                  appliedClass = "default-line-green";
                                }

                                return (
                                  <>
                                    <div className={appliedClass}></div>
                                    <span
                                      className="device-label-below-line"
                                      style={{
                                        position: "absolute",
                                        left: "50%",
                                        transform: "translateX(100%)",
                                        top: "19px", // Positions the text below the line segment in its busbar00
                                        color: "lime",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap", // ✅ Prevents line break
                                      }}
                                    >
                                      {deviceName}
                                    </span>
                                  </>
                                );
                              })
                            )}
                        </>
                      )}
                      {meterArray.map((item, itemIndex) => (
                        <React.Fragment key={itemIndex}>
                          {meterArray.length == 2 &&
                            item.label == "DG-1" &&
                            deviceData
                              .filter((e) => e.id == 372)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_DG_1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_1_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_1_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = offTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "GEB-1" &&
                            deviceData
                              .filter((e) => e.id == 371)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_GEB_1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_1_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_1_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = onTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "GEB-2" &&
                            deviceData
                              .filter((e) => e.id == 382)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;
                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_GEB_2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_2_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_GEB_2_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = onTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "DG-2" &&
                            deviceData
                              .filter((e) => e.id == 383)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_DG_2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_2_ON_FB"
                                  );

                                  const offTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_DG_2_OFF_FB"
                                  );
                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;
                                  const offValue = onTag
                                    ? Number(offTag["tagValue"])
                                    : 0;

                                  if (
                                    tripValue == 0 &&
                                    onValue == 1 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (
                                    tripValue == 1 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line1";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 1
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  } else if (
                                    tripValue == 0 &&
                                    onValue == 0 &&
                                    offValue == 0
                                  ) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          <img
                            src={lineDesign.dotIcon}
                            alt="dot-icon"
                            className="dot"
                          />
                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 374)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let image = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    image = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    image = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    image = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img src={image} alt="" className="cross" />
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F2 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 375)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 376)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F3 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 373)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_3F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_3F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F9 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 384)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_9F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_9F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 385)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F10 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 386)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}

                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 387)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <img
                                      src={appliedClass}
                                      alt=""
                                      className="cross"
                                    />
                                  );
                                })
                              )}
                          <div className="vertical-line"></div>

                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 374)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }
                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F2 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 375)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 376)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F3 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 373)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_3F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_3F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F9 O/G 2000A" &&
                            deviceData
                              .filter((e) => e.id == 384)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_9F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_9F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 400A" &&
                            deviceData
                              .filter((e) => e.id == 385)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F10 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 386)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}
                          {meterArray.length == 2 &&
                            item.label == "F10 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 387)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-off-upward"; // ✅ Case 1
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line"; // ✅ Case 2
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-on-upward";
                                  }

                                  return <div className={appliedClass}></div>;
                                })
                              )}

                          {item.direction == "upward" ? (
                            <div className="meter-unit">
                              <div className="meter-box">
                                <div className="meter-label">{item.label}</div>
                                <img
                                  src={lineDesign.meterBox}
                                  alt="meter-icon"
                                />
                                <div className="horizontal-line"></div>
                              </div>

                              <div className="meter-info">
                                <div className="meter-values">
                                  {item.label === "F2 O/G 400A" &&
                                    deviceData
                                      .filter((e) => e.id == 374)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F2 O/G 630A" &&
                                    deviceData
                                      .filter((e) => e.id == 375)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F2 O/G 1250A" &&
                                    deviceData
                                      .filter((e) => e.id == 376)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F3 O/G 2000A" &&
                                    deviceData
                                      .filter((e) => e.id == 373)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F9 O/G 2000A" &&
                                    deviceData
                                      .filter((e) => e.id == 384)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F10 O/G 400A" &&
                                    deviceData
                                      .filter((e) => e.id == 385)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                  {item.label === "F10 O/G 630A" &&
                                    deviceData
                                      .filter((e) => e.id == 386)
                                      .map((e) => {
                                        // 1. Define the desired order for the units (V, A, PF, KW, KVAR, KVA)
                                        const unitOrder = [
                                          "V",
                                          "A",
                                          "PF",
                                          "KW",
                                          "KVAR",
                                          "KVA",
                                        ];

                                        // 2. Filter and Sort the tags array based on the desired unit order
                                        const sortedTags = e.tags
                                          // Filter: Keep only the tags with units we want to display
                                          .filter((tags) =>
                                            unitOrder.includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          )
                                          // Sort: Arrange the tags according to the index in unitOrder
                                          .sort((a, b) => {
                                            const indexA = unitOrder.indexOf(
                                              a.tag_unit.toUpperCase()
                                            );
                                            const indexB = unitOrder.indexOf(
                                              b.tag_unit.toUpperCase()
                                            );
                                            return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                          });

                                        // 3. Map over the sorted array to calculate value and render the elements
                                        return sortedTags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          let label = "";

                                          // 4. Determine the label based on the unit
                                          switch (tags.tag_unit.toUpperCase()) {
                                            case "V":
                                              label = "VLL";
                                              break;
                                            case "A":
                                              label = "LN";
                                              break;
                                            case "PF":
                                              label = "QA";
                                              break;
                                            case "KW":
                                              label = "KT";
                                              break;
                                            case "KVAR":
                                              label = "KV";
                                              break;
                                            case "KVA":
                                              label = "KA";
                                              break;
                                            default:
                                              label = "";
                                          }

                                          // 5. Render the paragraph
                                          return (
                                            <p key={tags.id}>
                                              <span>
                                                {label} ({tags.tag_unit}):
                                              </span>{" "}
                                              {tagValue}
                                            </p>
                                          );
                                        });
                                      })}
                                  {item.label === "F10 O/G 1250A" &&
                                    deviceData
                                      .filter((e) => e.id == 387)
                                      .map((e) =>
                                        e.tags.map((tags) => {
                                          let tagValue = mergedArray.length
                                            ? mergedArray.find(
                                              (f) =>
                                                f.device__uid ==
                                                e.device__uid &&
                                                f.device_tag ==
                                                tags.device_tag
                                            )?.["tagValue"] || 0.0
                                            : 0.0;

                                          if (
                                            tags.is_soft_tag &&
                                            tags.soft_tag_id__formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            if (
                                              SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.softTagNotGetTag === true
                                            ) {
                                              tagValue = SoftTagFormula(
                                                tags.soft_tag_id__formula,
                                                mqttDataReduce
                                              )?.value;
                                            }
                                          }

                                          if (
                                            [
                                              "V",
                                              "A",
                                              "PF",
                                              "KW",
                                              "KVAR",
                                              "KVA",
                                            ].includes(
                                              tags.tag_unit.toUpperCase()
                                            )
                                          ) {
                                            let label = "";

                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          }

                                          return null;
                                        })
                                      )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="meter-unitData">
                              <ArrowDropDownIcon
                                style={{
                                  position: "absolute",
                                  top: "-99px",
                                  right: "-27px",
                                  cursor: "pointer",
                                  // Added for white color
                                  color: "white",
                                  // Added to increase the size (e.g., to 40px)
                                  fontSize: "40px",
                                }}
                                onClick={
                                  item.label === "DG-1" || item.label === "DG-2"
                                    ? () => setActivePage(3)
                                    : // It's generally better to pass null or undefined for no action, not an empty string
                                    () => setActivePage(5)
                                }
                              />

                              <div
                                className="vertical-line-to-meter"
                                style={{
                                  height: "225px",
                                  top: "-74px",
                                  left: "unset",
                                  right: "-8px",
                                }}
                              ></div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row-reverse",
                                }}
                              >
                                <div
                                  className="meter-box"
                                  style={{
                                    marginRight: "32px",
                                    marginTop: "-137px",
                                  }}
                                >
                                  <div className="meter-label">
                                    {item.label}
                                  </div>
                                  <img
                                    src={lineDesign.meterBox}
                                    alt="meter-icon"
                                  />
                                  <div
                                    className="horizontal-line"
                                    style={{ top: "1px" }}
                                  ></div>
                                </div>
                                <div
                                  className="meter-info"
                                  style={{ marginTop: "-10px" }}
                                >
                                  <div
                                    style={{ marginTop: "-10px" }}
                                    className={
                                      item.label !== "DG-1"
                                        ? "meter-values"
                                        : "meter-values "
                                    }
                                  >
                                    {item.label === "DG-1" &&
                                      deviceData
                                        .filter((e) => e.id == 372)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  tags.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                              tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }

                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}

                                    {item.label === "GEB-1" &&
                                      deviceData
                                        .filter((e) => e.id == 371)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  e.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                              tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }

                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}
                                    {item.label === "GEB-2" &&
                                      deviceData
                                        .filter((e) => e.id == 382)
                                        .map((e) =>
                                          e.tags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  e.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            if (
                                              [
                                                "V",
                                                "A",
                                                "PF",
                                                "KW",
                                                "KVAR",
                                                "KVA",
                                              ].includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            ) {
                                              let label = "";

                                              switch (
                                              tags.tag_unit.toUpperCase()
                                              ) {
                                                case "V":
                                                  label = "VLL";
                                                  break;
                                                case "A":
                                                  label = "LN";
                                                  break;
                                                case "PF":
                                                  label = "QA";
                                                  break;
                                                case "KW":
                                                  label = "KT";
                                                  break;
                                                case "KVAR":
                                                  label = "KV";
                                                  break;
                                                case "KVA":
                                                  label = "KA";
                                                  break;
                                                default:
                                                  label = "";
                                              }
                                              return (
                                                <p key={tags.id}>
                                                  <span>
                                                    {label} ({tags.tag_unit}):
                                                  </span>{" "}
                                                  {tagValue}
                                                </p>
                                              );
                                            }

                                            return null;
                                          })
                                        )}
                                    {item.label === "DG-2" &&
                                      deviceData
                                        .filter((e) => e.id == 383)
                                        .map((e) => {
                                          // 1. Define the desired order for the units
                                          const unitOrder = [
                                            "V",
                                            "A",
                                            "PF",
                                            "KW",
                                            "KVAR",
                                            "KVA",
                                          ];

                                          // 2. Sort the tags array based on the desired unit order
                                          const sortedTags = e.tags
                                            // Filter out tags that are not in the unitOrder list
                                            .filter((tags) =>
                                              unitOrder.includes(
                                                tags.tag_unit.toUpperCase()
                                              )
                                            )
                                            // Sort the remaining tags
                                            .sort((a, b) => {
                                              const indexA = unitOrder.indexOf(
                                                a.tag_unit.toUpperCase()
                                              );
                                              const indexB = unitOrder.indexOf(
                                                b.tag_unit.toUpperCase()
                                              );
                                              return indexA - indexB;
                                            });

                                          // 3. Map over the sorted array to render the elements
                                          return sortedTags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  e.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            let label = "";

                                            // 4. Determine the label based on the unit
                                            switch (
                                            tags.tag_unit.toUpperCase()
                                            ) {
                                              case "V":
                                                label = "VLL";
                                                break;
                                              case "A":
                                                label = "LN";
                                                break;
                                              case "PF":
                                                label = "QA";
                                                break;
                                              case "KW":
                                                label = "KT";
                                                break;
                                              case "KVAR":
                                                label = "KV";
                                                break;
                                              case "KVA":
                                                label = "KA";
                                                break;
                                              default:
                                                label = "";
                                            }

                                            // 5. Render the paragraph
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          });
                                        })}
                                  </div>
                                </div>
                              </div>

                              {item.label == "DG-1" && deviceData
                                .filter((e) => e.id == 372)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;
                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_DG_1_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_1_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_1_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {item.label == "GEB-1" && deviceData
                                .filter((e) => e.id == 371)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;
                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_GEB_1_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_1_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_1_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {item.label == "GEB-2" && deviceData
                                .filter((e) => e.id == 382)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;

                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_GEB_2_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_2_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_GEB_2_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {item.label == "DG-2" && deviceData
                                .filter((e) => e.id == 383)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;

                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_DG_2_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_2_ON_FB"
                                    );
                                    const offTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_DG_2_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;
                                    const offValue = offTag
                                      ? Number(offTag["tagValue"])
                                      : 0;

                                    if (
                                      tripValue == 0 &&
                                      onValue == 1 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 1 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 1
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (
                                      tripValue == 0 &&
                                      onValue == 0 &&
                                      offValue == 0
                                    ) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                            </div>
                          )}

                          <div className="vertical-line-to-meter"></div>
                        </React.Fragment>
                      ))}
                    </div>
                  );
                })}
              </div>
              <button
                style={{
                  width: "150px",
                  padding: "15px",
                  fontSize: "18px",
                  cursor: "pointer",
                  marginTop: "-69px"
                }}
                onClick={() => setActivePage(4)}
              >
                HT PANEL
              </button>
            </>
          )}
          {activePage !== 2 &&
            activePage !== 3 &&
            activePage !== 4 &&
            activePage !== 5 && (
              <img
                src={lineDesign.rightArrowIcon}
                alt="right-arrow"
                className="right-arrow"
                style={{ cursor: "pointer" }}
                onClick={() => handleNextClick()}
              />
            )}
          {activePage == 2 && (
            <div className="busbar2">
              {meters1.map((meter, index) => (
                <div key={index} className="connection-point">
                  <img
                    src={lineDesign.dotIcon}
                    alt="dot-icon"
                    className="dot"
                  />
                  <div className="vertical-line"></div>
                  {meter.label == "F11 O/G 100A" &&
                    deviceData
                      .filter((e) => e.id == 388)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 2 &&
                    deviceData
                      .filter((e) => e.id == 389)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F3_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 3 &&
                    deviceData
                      .filter((e) => e.id == 390)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F4_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F4_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "F11 O/G 200A" &&
                    deviceData
                      .filter((e) => e.id == 391)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F5_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F5_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "F11 O/G 100A" &&
                    deviceData
                      .filter((e) => e.id == 388)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 2 &&
                    deviceData
                      .filter((e) => e.id == 389)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F3_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F11 O/G 125A" &&
                    meter.id == 3 &&
                    deviceData
                      .filter((e) => e.id == 390)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F4_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F4_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "F11 O/G 200A" &&
                    deviceData
                      .filter((e) => e.id == 391)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_11F5_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_11F5_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;

                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (tripValue == 1 && onValue == 0) {
                            appliedClass = "diagonal-line";
                          } else if (tripValue == 0 && onValue == 0) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {/* <div className="diagonal-line"></div> */}
                  <div className="meter-unit">
                    <div className="meter-box">
                      <div className="meter-label">{meter.label}</div>
                      <img src={lineDesign.meterBox} alt="meter-icon" />
                      <div className="horizontal-line"></div>
                    </div>
                    <div className="meter-info">
                      <div className="meter-values">
                        {meter.label === "F11 O/G 100A" &&
                          deviceData
                            .filter((e) => e.id == 388)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}

                        {meter.label === "F11 O/G 125A" &&
                          meter.id == 2 &&
                          deviceData
                            .filter((e) => e.id == 389)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F11 O/G 125A" &&
                          meter.id == 3 &&
                          deviceData
                            .filter((e) => e.id == 390)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "F11 O/G 200A" &&
                          deviceData
                            .filter((e) => e.id == 391)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }

                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                      </div>
                    </div>
                  </div>
                  <div className="vertical-line-to-meter"></div>
                </div>
              ))}
            </div>
          )}

          {activePage == 3 && (
            <>
              <div className="busbar2">
                {metersData3.map((meterArray, index) => {
                  return (
                    <div
                      key={index}
                      // className={`connection-point ${shouldBreak(index) ? "break-busbar" : ""}`}
                      className="connection-point"
                    >
                      {meterArray.map((item, itemIndex) => (
                        <React.Fragment key={itemIndex}>
                          <img
                            src={lineDesign.dotIcon}
                            alt="dot-icon"
                            className="dot"
                          />
                          {item.label == "SYNCH RELAY 1" &&
                            deviceData
                              .filter((e) => e.id == 392)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_1_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_1_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line1";
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-off";
                                  }
                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {item.label == "SYNCH RELAY 2" &&
                            deviceData
                              .filter((e) => e.id == 392)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line1";
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-off";
                                  }
                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {item.label == "SYNCH RELAY 3" &&
                            deviceData
                              .filter((e) => e.id == 392)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line1";
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {item.label == "SYNCH RELAY 4" &&
                            deviceData
                              .filter((e) => e.id == 392)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == e.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";

                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_4_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_SYNCH_DG_4_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = "diagonal-line-on";
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = "diagonal-line1";
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = "diagonal-line-off";
                                  }

                                  return (
                                    <>
                                      <div className={appliedClass}></div>

                                      <div
                                        className="vertical-line"
                                        style={{ top: "-28px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}
                          {meterArray.length == 1 &&
                            item.label == "F2 O/G 1250A" &&
                            deviceData
                              .filter((e) => e.id == 376)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_2F3_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_2F3_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <>
                                      <div
                                        className="vertical-line-to-meter"
                                        style={{ top: "16px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}

                          {meterArray.length == 1 &&
                            item.label == "F10 O/G 630A" &&
                            deviceData
                              .filter((e) => e.id == 386)
                              .map((e) =>
                                e.tags.map((tags) => {
                                  let tagValue = mergedArray.length
                                    ? mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == tags.device_tag
                                    )?.["tagValue"] || 0.0
                                    : 0.0;

                                  let appliedClass = "";
                                  const tripTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == "P_10F2_TRIP_FB"
                                  );
                                  const onTag = mergedArray.find(
                                    (f) =>
                                      f.device__uid === tags.device__uid &&
                                      f.device_tag == "P_10F2_ON_OFF_FB"
                                  );

                                  const tripValue = tripTag
                                    ? Number(tripTag["tagValue"])
                                    : 0;
                                  const onValue = onTag
                                    ? Number(onTag["tagValue"])
                                    : 0;

                                  if (tripValue == 0 && onValue == 1) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  } else if (tripValue == 1 && onValue == 0) {
                                    appliedClass = lineDesign.crossIcon;
                                  } else if (tripValue == 0 && onValue == 0) {
                                    appliedClass = lineDesign.crossRedIcon;
                                  }

                                  return (
                                    <>
                                      <div
                                        className="vertical-line-to-meter"
                                        style={{ top: "16px" }}
                                      ></div>
                                    </>
                                  );
                                })
                              )}

                          {item.direction == "upward" ? (
                            <></>
                          ) : (
                            <div className="meter-unitData">
                              <div
                                className="vertical-line-to-meter"
                                style={{
                                  height: "225px",
                                  top: "-74px",
                                  left: "unset",
                                  right: "-8px",
                                }}
                              ></div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row-reverse",
                                }}
                              >
                                <div
                                  className="meter-box"
                                  style={{
                                    marginRight: "32px",
                                    marginTop: "-137px",
                                  }}
                                >
                                  <div className="meter-label">
                                    {item.label}
                                  </div>
                                  <img
                                    src={lineDesign.meterBox}
                                    alt="meter-icon"
                                  />
                                  <div
                                    className="horizontal-line"
                                    style={{ top: "1px" }}
                                  ></div>
                                </div>
                                <div
                                  className="meter-info"
                                  style={{ marginTop: "-10px" }}
                                >
                                  <div
                                    style={{ marginTop: "-10px" }}
                                    className={
                                      item.label !== "DG-1"
                                        ? "meter-values"
                                        : "meter-values "
                                    }
                                  >
                                    {item.label === "SYNCH RELAY 1" &&
                                      deviceData
                                        .filter((e) => e.id == 427)
                                        .map((e) => {
                                          // 1. Define the desired order for the specific units
                                          const unitOrder = [
                                            "Volt RY",
                                            "Volt YB",
                                            "Volt BR",
                                            "kW",
                                           
                                          ];

                                          // 2. Filter and Sort the tags array based on the desired unit order
                                          const sortedTags = e.tags
                                            // Filter: Keep only the tags with units defined in unitOrder
                                            .filter((tags) =>
                                              unitOrder.includes(tags?.tag_unit)
                                            )
                                            // Sort: Arrange the tags according to the index in unitOrder
                                            .sort((a, b) => {
                                              const indexA = unitOrder.indexOf(
                                                a.tag_unit
                                              );
                                              const indexB = unitOrder.indexOf(
                                                b.tag_unit
                                              );
                                              return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                            });

                                          // 3. Map over the sorted array to calculate value and render the elements
                                          return sortedTags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  tags.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            // Apply SoftTagFormula logic if applicable
                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            let label = "";

                                            // 4. Determine the label based on the unit
                                            switch (tags?.tag_unit) {
                                              case "Volt RY":
                                                label = "V12";
                                                break;
                                              case "Volt YB":
                                                label = "V23";
                                                break;
                                              case "Volt BR":
                                                label = "V31";
                                                break;
                                              case "kW":
                                                label = "KT";
                                                break;

                                              default:
                                                label = "";
                                            }

                                            // 5. Render the paragraph
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          });
                                        })}

                                    {item.label === "SYNCH RELAY 2" &&
                                      deviceData
                                        .filter((e) => e.id == 428)
                                        .map((e) => {
                                          // 1. Define the desired order for the specific units
                                          const unitOrder = [
                                            "Volt RY",
                                            "Volt YB",
                                            "Volt BR",
                                            "kW",
                                           
                                          ];

                                          // 2. Filter and Sort the tags array based on the desired unit order
                                          const sortedTags = e.tags
                                            // Filter: Keep only the tags with units defined in unitOrder
                                            .filter((tags) =>
                                              unitOrder.includes(tags?.tag_unit)
                                            )
                                            // Sort: Arrange the tags according to the index in unitOrder
                                            .sort((a, b) => {
                                              const indexA = unitOrder.indexOf(
                                                a.tag_unit
                                              );
                                              const indexB = unitOrder.indexOf(
                                                b.tag_unit
                                              );
                                              return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                            });

                                          // 3. Map over the sorted array to calculate value and render the elements
                                          return sortedTags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  e.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            // Apply SoftTagFormula logic if applicable
                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            let label = "";

                                            // 4. Determine the label based on the unit
                                            switch (tags?.tag_unit) {
                                              case "Volt RY":
                                                label = "V12";
                                                break;
                                              case "Volt YB":
                                                label = "V23";
                                                break;
                                              case "Volt BR":
                                                label = "V31";
                                                break;
                                              case "kW":
                                                label = "KT";
                                                break;

                                              default:
                                                label = ""; // Should not be reached if filter is correct
                                            }

                                            // 5. Render the paragraph
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          });
                                        })}
                                    {item.label === "SYNCH RELAY 3" &&
                                      deviceData
                                        .filter((e) => e.id == 429)
                                        .map((e) => {
                                          // 1. Define the desired order for the specific units
                                          const unitOrder = [
                                            "Volt RY",
                                            "Volt YB",
                                            "Volt BR",
                                            "kW",
                                           
                                          ];

                                          // 2. Filter and Sort the tags array based on the desired unit order
                                          const sortedTags = e.tags
                                            // Filter: Keep only the tags with units defined in unitOrder
                                            .filter((tags) =>
                                              unitOrder.includes(tags?.tag_unit)
                                            )
                                            // Sort: Arrange the tags according to the index in unitOrder
                                            .sort((a, b) => {
                                              const indexA = unitOrder.indexOf(
                                                a.tag_unit
                                              );
                                              const indexB = unitOrder.indexOf(
                                                b.tag_unit
                                              );
                                              return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                            });

                                          // 3. Map over the sorted array to calculate value and render the elements
                                          return sortedTags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  e.device__uid && // Changed from tags.device__uid to e.device__uid for consistency with previous blocks
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            // Apply SoftTagFormula logic if applicable
                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            let label = "";

                                            // 4. Determine the label based on the unit
                                            switch (tags?.tag_unit) {
                                              case "Volt RY":
                                                label = "V12";
                                                break;
                                              case "Volt YB":
                                                label = "V23";
                                                break;
                                              case "Volt BR":
                                                label = "V31";
                                                break;
                                              case "kW":
                                                label = "KT";
                                                break;

                                              default:
                                                label = ""; // Should not be reached if filter is correct
                                            }

                                            // 5. Render the paragraph
                                            // Note: Removed redundant `<>` fragment wrapping `<p>`
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          });
                                        })}
                                    {item.label === "SYNCH RELAY 4" &&
                                      deviceData
                                        .filter((e) => e.id == 430)
                                        .map((e) => {
                                          // 1. Define the desired order for the specific units
                                          const unitOrder = [
                                            "Volt RY",
                                            "Volt YB",
                                            "Volt BR",
                                            "kW",
                                            
                                          ];

                                          // 2. Filter and Sort the tags array based on the desired unit order
                                          const sortedTags = e.tags
                                            // Filter: Keep only the tags with units defined in unitOrder
                                            .filter((tags) =>
                                              unitOrder.includes(tags?.tag_unit)
                                            )
                                            // Sort: Arrange the tags according to the index in unitOrder
                                            .sort((a, b) => {
                                              const indexA = unitOrder.indexOf(
                                                a.tag_unit
                                              );
                                              const indexB = unitOrder.indexOf(
                                                b.tag_unit
                                              );
                                              return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                            });

                                          // 3. Map over the sorted array to calculate value and render the elements
                                          return sortedTags.map((tags) => {
                                            let tagValue = mergedArray.length
                                              ? mergedArray.find(
                                                (f) =>
                                                  f.device__uid ==
                                                  e.device__uid &&
                                                  f.device_tag ==
                                                  tags.device_tag
                                              )?.["tagValue"] || 0.0
                                              : 0.0;

                                            // Apply SoftTagFormula logic if applicable
                                            if (
                                              tags.is_soft_tag &&
                                              tags.soft_tag_id__formula &&
                                              Object.keys(mqttDataReduce).length
                                            ) {
                                              if (
                                                SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.softTagNotGetTag === true
                                              ) {
                                                tagValue = SoftTagFormula(
                                                  tags.soft_tag_id__formula,
                                                  mqttDataReduce
                                                )?.value;
                                              }
                                            }

                                            let label = "";

                                            // 4. Determine the label based on the unit
                                            switch (tags?.tag_unit) {
                                              case "Volt RY":
                                                label = "V12";
                                                break;
                                              case "Volt YB":
                                                label = "V23";
                                                break;
                                              case "Volt BR":
                                                label = "V31";
                                                break;
                                              case "kW":
                                                label = "KT";
                                                break;

                                              default:
                                                label = ""; // Should not be reached if filter is correct
                                            }

                                            // 5. Render the paragraph
                                            return (
                                              <p key={tags.id}>
                                                <span>
                                                  {label} ({tags.tag_unit}):
                                                </span>{" "}
                                                {tagValue}
                                              </p>
                                            );
                                          });
                                        })}
                                  </div>
                                </div>
                              </div>

                              {item.label == "SYNCH RELAY 1" && deviceData
                                .filter((e) => e.id == 392)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;
                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_1_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_1_ON_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;

                                    if (tripValue == 0 && onValue == 1) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (tripValue == 1 && onValue == 0) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (tripValue == 0 && onValue == 0) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {item.label == "SYNCH RELAY 2" && deviceData
                                .filter((e) => e.id == 392)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;
                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_2_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_2_ON_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;

                                    if (tripValue == 0 && onValue == 1) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (tripValue == 1 && onValue == 0) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (tripValue == 0 && onValue == 0) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {item.label == "SYNCH RELAY 3" && deviceData
                                .filter((e) => e.id == 392)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;

                                    let appliedClass = "";
                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_3_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_3_ON_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;

                                    if (tripValue == 0 && onValue == 1) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (tripValue == 1 && onValue == 0) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (tripValue == 0 && onValue == 0) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }
                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                              {item.label == "SYNCH RELAY 4" && deviceData
                                .filter((e) => e.id == 392)
                                .map((e) =>
                                  e.tags.map((tags) => {
                                    let tagValue = mergedArray.length
                                      ? mergedArray.find(
                                        (f) =>
                                          f.device__uid == e.device__uid &&
                                          f.device_tag == tags.device_tag
                                      )?.["tagValue"] || 0.0
                                      : 0.0;

                                    let appliedClass = "";

                                    const tripTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid == tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_4_TRIP_FB"
                                    );
                                    const onTag = mergedArray.find(
                                      (f) =>
                                        f.device__uid === tags.device__uid &&
                                        f.device_tag == "P_SYNCH_DG_4_ON_OFF_FB"
                                    );

                                    const tripValue = tripTag
                                      ? Number(tripTag["tagValue"])
                                      : 0;
                                    const onValue = onTag
                                      ? Number(onTag["tagValue"])
                                      : 0;

                                    if (tripValue == 0 && onValue == 1) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    } else if (tripValue == 1 && onValue == 0) {
                                      appliedClass = lineDesign.crossIcon;
                                    } else if (tripValue == 0 && onValue == 0) {
                                      appliedClass = lineDesign.crossRedIcon;
                                    }

                                    return (
                                      <>
                                        <img
                                          src={appliedClass}
                                          alt=""
                                          className="cross"
                                          style={{
                                            top: "140px",
                                            left: "unset",
                                            right: "-22px",
                                          }}
                                        />
                                      </>
                                    );
                                  })
                                )}
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {activePage == 4 && (
            <div className="busbar2" style={{ transform: "translate(53px, 271px)" }}>
              {meters2.map((meter, index) => (
                <div key={index} className="connection-point">
                  <img
                    src={lineDesign.dotIcon}
                    alt="dot-icon"
                    className="dot"
                  />
                  <div className="vertical-line"></div>
                  {meter.label == "HT Meter 1" &&
                    deviceData
                      .filter((e) => e.id == 424)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_HTP_1_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_1_ON_FB"
                          );
                          const offTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_1_OFF_FB"
                          );
                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;
                          const offValue = offTag
                            ? Number(offTag["tagValue"])
                            : 0;

                          if (tripValue == 0 && onValue == 1 && offValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 1 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 1
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "HT Meter 2" &&
                    deviceData
                      .filter((e) => e.id == 425)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_HTP_2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_2_ON_FB"
                          );
                          const offTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_2_OFF_FB"
                          );
                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;
                          const offValue = offTag
                            ? Number(offTag["tagValue"])
                            : 0;

                          if (tripValue == 0 && onValue == 1 && offValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 1 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 1
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "HT Meter 3" &&
                    deviceData
                      .filter((e) => e.id == 426)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_HTP_3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_3_ON_FB"
                          );
                          const offTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_3_OFF_FB"
                          );
                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;
                          const offValue = offTag
                            ? Number(offTag["tagValue"])
                            : 0;

                          if (tripValue == 0 && onValue == 1 && offValue == 0) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 1 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 1
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}

                  {meter.label == "HT Meter 1" &&
                    deviceData
                      .filter((e) => e.id == 424)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";

                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_HTP_1_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_1_ON_FB"
                          );
                          const offTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_1_OFF_FB"
                          );
                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;
                          const offValue = offTag
                            ? Number(offTag["tagValue"])
                            : 0;

                          if (tripValue == 0 && onValue == 1 && offValue == 0) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (
                            tripValue == 1 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = "diagonal-line";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 1
                          ) {
                            appliedClass = "diagonal-line-green";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "HT Meter 2" &&
                    deviceData
                      .filter((e) => e.id == 425)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_HTP_2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_2_ON_FB"
                          );
                          const offTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_2_OFF_FB"
                          );
                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;
                          const offValue = offTag
                            ? Number(offTag["tagValue"])
                            : 0;

                          if (tripValue == 0 && onValue == 1 && offValue == 0) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (
                            tripValue == 1 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = "diagonal-line";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 1
                          ) {
                            appliedClass = "diagonal-line-green";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "HT Meter 3" &&
                    deviceData
                      .filter((e) => e.id == 426)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_HTP_3_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_3_ON_FB"
                          );
                          const offTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_HTP_3_OFF_FB"
                          );
                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;
                          const offValue = offTag
                            ? Number(offTag["tagValue"])
                            : 0;

                          if (tripValue == 0 && onValue == 1 && offValue == 0) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (
                            tripValue == 1 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = "diagonal-line";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 1
                          ) {
                            appliedClass = "diagonal-line-green";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0 &&
                            offValue == 0
                          ) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {/* <div className="diagonal-line"></div> */}
                  <div className="meter-unit">
                    <div className="meter-box">
                      <div className="meter-label">{meter.label}</div>
                      <img src={lineDesign.meterBox} alt="meter-icon" />
                      <div className="horizontal-line"></div>
                    </div>
                    <div className="meter-info">
                      <div className="meter-values">
                        {meter.label === "HT Meter 1" &&
                          deviceData
                            .filter((e) => e.id == 424)
                            .map((e) => {
                              // 1. Define the desired order for the units (V, A, PF, KW, KVAR, KVA)
                              const unitOrder = [
                                "V",
                                "A",
                                "PF",
                                "KW",
                                "KVAR",
                                "KVA",
                              ];

                              // 2. Filter and Sort the tags array based on the desired unit order
                              const sortedTags = e.tags
                                // Filter: Keep only the tags with units we want to display
                                .filter((tags) =>
                                  unitOrder.includes(
                                    tags.tag_unit.toUpperCase()
                                  )
                                )
                                // Sort: Arrange the tags according to the index in unitOrder
                                .sort((a, b) => {
                                  const indexA = unitOrder.indexOf(
                                    a.tag_unit.toUpperCase()
                                  );
                                  const indexB = unitOrder.indexOf(
                                    b.tag_unit.toUpperCase()
                                  );
                                  return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                });

                              // 3. Map over the sorted array to calculate value and render the elements
                              return sortedTags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                let label = "";

                                // 4. Determine the label based on the unit
                                switch (tags.tag_unit.toUpperCase()) {
                                  case "V":
                                    label = "VLL";
                                    break;
                                  case "A":
                                    label = "LN";
                                    break;
                                  case "PF":
                                    label = "QA";
                                    break;
                                  case "KW":
                                    label = "KT";
                                    break;
                                  case "KVAR":
                                    label = "KV";
                                    break;
                                  case "KVA":
                                    label = "KA";
                                    break;
                                  default:
                                    label = ""; // Should not happen if filter is correct
                                }

                                // 5. Render the paragraph
                                return (
                                  <p key={tags.id}>
                                    <span>
                                      {label} ({tags.tag_unit}):
                                    </span>{" "}
                                    {tagValue}
                                  </p>
                                );
                              });
                            })}

                        {meter.label === "HT Meter 2" &&
                          deviceData
                            .filter((e) => e.id == 425)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                        {meter.label === "HT Meter 3" &&
                          deviceData
                            .filter((e) => e.id == 426)
                            .map((e) =>
                              e.tags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                if (
                                  [
                                    "V",
                                    "A",
                                    "PF",
                                    "KW",
                                    "KVAR",
                                    "KVA",
                                  ].includes(tags.tag_unit.toUpperCase())
                                ) {
                                  let label = "";

                                  switch (tags.tag_unit.toUpperCase()) {
                                    case "V":
                                      label = "VLL";
                                      break;
                                    case "A":
                                      label = "LN";
                                      break;
                                    case "PF":
                                      label = "QA";
                                      break;
                                    case "KW":
                                      label = "KT";
                                      break;
                                    case "KVAR":
                                      label = "KV";
                                      break;
                                    case "KVA":
                                      label = "KA";
                                      break;
                                    default:
                                      label = "";
                                  }
                                  return (
                                    <p key={tags.id}>
                                      <span>
                                        {label} ({tags.tag_unit}):
                                      </span>{" "}
                                      {tagValue}
                                    </p>
                                  );
                                }

                                return null;
                              })
                            )}
                      </div>
                    </div>
                  </div>
                  <div className="vertical-line-to-meter"></div>
                </div>
              ))}
            </div>
          )}

          {activePage == 5 && (
            <div className="busbar2" style={{ transform: "translate(53px, 271px)", justifyContent:"space-evenly" }}>
              {meters3.map((meter, index) => (
                <div key={index} className="connection-point">
                  <img
                    src={lineDesign.dotIcon}
                    alt="dot-icon"
                    className="dot"
                  />
                  <div className="vertical-line"></div>
                  {meter.label == "2000 A-1" &&
                    deviceData
                      .filter((e) => e.id == 392)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_2000A_1_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_2000A_1_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;


                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 1 &&
                            onValue == 0
                          ) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}
                  {meter.label == "2000 A-2" &&
                    deviceData
                      .filter((e) => e.id == 392)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_2000A_2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_2000A_2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;


                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = lineDesign.crossRedIcon;
                          } else if (
                            tripValue == 1 &&
                            onValue == 0
                          ) {
                            appliedClass = lineDesign.crossIcon;
                          } else if (
                            tripValue == 0 &&
                            onValue == 0
                          ) {
                            appliedClass = lineDesign.crossRedIcon;
                          }

                          return (
                            <img src={appliedClass} alt="" className="cross" />
                          );
                        })
                      )}


                  {meter.label == "2000 A-1" &&
                    deviceData
                      .filter((e) => e.id == 392)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";

                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_2000A_1_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_2000A_1_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;


                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (
                            tripValue == 1 &&
                            onValue == 0
                          ) {
                            appliedClass = "diagonal-line";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0
                          ) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}
                  {meter.label == "2000 A-2" &&
                    deviceData
                      .filter((e) => e.id == 392)
                      .map((e) =>
                        e.tags.map((tags) => {
                          let tagValue = mergedArray.length
                            ? mergedArray.find(
                              (f) =>
                                f.device__uid == tags.device__uid &&
                                f.device_tag == tags.device_tag
                            )?.["tagValue"] || 0.0
                            : 0.0;

                          let appliedClass = "";
                          const tripTag = mergedArray.find(
                            (f) =>
                              f.device__uid == tags.device__uid &&
                              f.device_tag == "P_2000A_2_TRIP_FB"
                          );
                          const onTag = mergedArray.find(
                            (f) =>
                              f.device__uid === tags.device__uid &&
                              f.device_tag == "P_2000A_2_ON_OFF_FB"
                          );

                          const tripValue = tripTag
                            ? Number(tripTag["tagValue"])
                            : 0;
                          const onValue = onTag ? Number(onTag["tagValue"]) : 0;


                          if (tripValue == 0 && onValue == 1) {
                            appliedClass = "diagonal-line-off-upward";
                          } else if (
                            tripValue == 1 &&
                            onValue == 0
                          ) {
                            appliedClass = "diagonal-line";
                          } else if (
                            tripValue == 0 &&
                            onValue == 0
                          ) {
                            appliedClass = "diagonal-line-green";
                          }

                          return <div className={appliedClass}></div>;
                        })
                      )}

                  {/* <div className="diagonal-line"></div> */}
                  <div className="meter-unit">
                    <div className="meter-box">
                      <div className="meter-label">{meter.label}</div>
                      <img src={lineDesign.meterBox} alt="meter-icon" />
                      <div className="horizontal-line"></div>
                    </div>
                    <div className="meter-info">
                      <div className="meter-values">
                        {meter.label === "2000 A-1" &&
                          deviceData
                            .filter((e) => e.id == 431)
                            .map((e) => {
                              // 1. Define the desired order for the units (V, A, PF, KW, KVAR, KVA)
                              const unitOrder = [
                                "V",
                                "A",
                                "PF",
                                "KW",
                                "KVAR",
                                "KVA",
                              ];

                              // 2. Filter and Sort the tags array based on the desired unit order
                              const sortedTags = e.tags
                                // Filter: Keep only the tags with units we want to display
                                .filter((tags) =>
                                  unitOrder.includes(
                                    tags.tag_unit.toUpperCase()
                                  )
                                )
                                // Sort: Arrange the tags according to the index in unitOrder
                                .sort((a, b) => {
                                  const indexA = unitOrder.indexOf(
                                    a.tag_unit.toUpperCase()
                                  );
                                  const indexB = unitOrder.indexOf(
                                    b.tag_unit.toUpperCase()
                                  );
                                  return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                });

                              // 3. Map over the sorted array to calculate value and render the elements
                              return sortedTags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                let label = "";

                                // 4. Determine the label based on the unit
                                switch (tags.tag_unit.toUpperCase()) {
                                  case "V":
                                    label = "VLL";
                                    break;
                                  case "A":
                                    label = "LN";
                                    break;
                                  case "PF":
                                    label = "QA";
                                    break;
                                  case "KW":
                                    label = "KT";
                                    break;
                                  case "KVAR":
                                    label = "KV";
                                    break;
                                  case "KVA":
                                    label = "KA";
                                    break;
                                  default:
                                    label = ""; // Should not happen if filter is correct
                                }

                                // 5. Render the paragraph
                                return (
                                  <p key={tags.id}>
                                    <span>
                                      {label} ({tags.tag_unit}):
                                    </span>{" "}
                                    {tagValue}
                                  </p>
                                );
                              });
                            })}

                        {meter.label === "2000 A-2" &&
                          deviceData
                            .filter((e) => e.id == 432)
                            .map((e) => {
                              // 1. Define the desired order for the units (V, A, PF, KW, KVAR, KVA)
                              const unitOrder = [
                                "V",
                                "A",
                                "PF",
                                "KW",
                                "KVAR",
                                "KVA",
                              ];

                              // 2. Filter and Sort the tags array based on the desired unit order
                              const sortedTags = e.tags
                                // Filter: Keep only the tags with units we want to display
                                .filter((tags) =>
                                  unitOrder.includes(
                                    tags.tag_unit.toUpperCase()
                                  )
                                )
                                // Sort: Arrange the tags according to the index in unitOrder
                                .sort((a, b) => {
                                  const indexA = unitOrder.indexOf(
                                    a.tag_unit.toUpperCase()
                                  );
                                  const indexB = unitOrder.indexOf(
                                    b.tag_unit.toUpperCase()
                                  );
                                  return indexA - indexB; // Lower index (earlier in unitOrder) comes first
                                });

                              // 3. Map over the sorted array to calculate value and render the elements
                              return sortedTags.map((tags) => {
                                let tagValue = mergedArray.length
                                  ? mergedArray.find(
                                    (f) =>
                                      f.device__uid == tags.device__uid &&
                                      f.device_tag == tags.device_tag
                                  )?.["tagValue"] || 0.0
                                  : 0.0;

                                if (
                                  tags.is_soft_tag &&
                                  tags.soft_tag_id__formula &&
                                  Object.keys(mqttDataReduce).length
                                ) {
                                  if (
                                    SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag === true
                                  ) {
                                    tagValue = SoftTagFormula(
                                      tags.soft_tag_id__formula,
                                      mqttDataReduce
                                    )?.value;
                                  }
                                }

                                let label = "";

                                // 4. Determine the label based on the unit
                                switch (tags.tag_unit.toUpperCase()) {
                                  case "V":
                                    label = "VLL";
                                    break;
                                  case "A":
                                    label = "LN";
                                    break;
                                  case "PF":
                                    label = "QA";
                                    break;
                                  case "KW":
                                    label = "KT";
                                    break;
                                  case "KVAR":
                                    label = "KV";
                                    break;
                                  case "KVA":
                                    label = "KA";
                                    break;
                                  default:
                                    label = ""; // Should not happen if filter is correct
                                }

                                // 5. Render the paragraph
                                return (
                                  <p key={tags.id}>
                                    <span>
                                      {label} ({tags.tag_unit}):
                                    </span>{" "}
                                    {tagValue}
                                  </p>
                                );
                              });
                            })}

                      </div>
                    </div>
                  </div>
                  <div className="vertical-line-to-meter"></div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LineDesign;
